import {
    createApi,
    fetchBaseQuery
  } from "@reduxjs/toolkit/query/react";

const APIM_SUBSCRIPTION_VALUE = process.env.REACT_APP_FIELD_BOUNDARY_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_FIELD_BOUNDARY_API_URL

export interface queryParam {
    lat: number,
    lon: number,
    obstacle?: boolean,
    polygon? : string
}

export interface StringMap {
    [key: string]: string
}

export interface FieldBoundaryResultType {
    data: StringMap[],
    error: any,
    isLoading: boolean
}

export const mapApi = createApi({
    reducerPath: "mapApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: async (headers, { getState }) => {
            headers.set('Content-Type', `application/json`)
            headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
            // headers.set('Authorization', `Bearer ${state.auth.idToken}`)
            return headers
        }
    }),
    tagTypes: ["Map"],
    endpoints: (builder) => ({
        getFieldBoundary: builder.mutation({
            query: (body: queryParam) => ({
                url: `/data`,
                method: 'POST',
                body
            })
        }),
        })
    })
    
export const {
    useGetFieldBoundaryMutation
  } = mapApi;